// 👥 Employés E4 — Section 1 : Identité & coordonnées (clé RBAC `infos`). Bloc Statut E2 en tête.
import { Input } from '@/components/ui/input';
import { User } from 'lucide-react';
import { useEditionSection } from '@/hooks/useEditionSection';
import { SectionFiche, Champ } from './SectionFiche';
import { BlocStatutEmploye } from '@/components/employes/BlocStatutEmploye';

export const CHAMPS_IDENTITE = ['prenom', 'nom', 'surnom', 'date_naissance', 'numero_employe', 'code_acces_plateforme_paie', 'email', 'telephone', 'telephone_urgence', 'adresse', 'ville', 'code_postal', 'couleur_equipe'];

export function SectionIdentite({ employee, isProprietaire, onStatutChange, onInviter }) {
  const ed = useEditionSection('infos', CHAMPS_IDENTITE);
  const T = (c, label, type = 'text', props = {}) => (
    <Champ key={c} label={label} valeur={ed.valeur(c)} enEdition={ed.enEdition} erreur={ed.erreurs[c]} testid={`champ-${c}`}>
      <Input type={type} value={ed.brouillon[c] ?? ''} onChange={(e) => ed.changer(c, e.target.value)} className="mt-0.5 h-8" data-testid={`input-${c}`} {...props} />
    </Champ>
  );
  return (
    <SectionFiche cle="infos" titre="Identité & coordonnées" icone={User} peutModifier={isProprietaire} edition={ed}>
      <div className="mb-4">
        <BlocStatutEmploye key={employee.id} employee={employee} isProprietaire={isProprietaire} onChanged={onStatutChange} onInviter={onInviter} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {T('prenom', 'Prénom')}{T('nom', 'Nom')}{T('surnom', 'Surnom', 'text', { maxLength: 50 })}
        {T('date_naissance', 'Date de naissance', 'date')}{T('numero_employe', "Numéro d'employé")}{T('code_acces_plateforme_paie', 'Code d\'accès plateforme de paie')}
        {T('email', 'Courriel', 'email')}{T('telephone', 'Téléphone', 'tel')}{T('telephone_urgence', "Téléphone d'urgence", 'tel')}
        {T('adresse', 'Adresse')}{T('ville', 'Ville')}{T('code_postal', 'Code postal')}
        <Champ label="Couleur d'équipe" valeur={null} enEdition={ed.enEdition} testid="champ-couleur_equipe" vide="">
          <input type="color" value={ed.brouillon.couleur_equipe || '#3B82F6'} onChange={(e) => ed.changer('couleur_equipe', e.target.value)} className="mt-0.5 h-8 w-16 rounded border" data-testid="input-couleur_equipe" />
        </Champ>
        {!ed.enEdition && <div className="-mt-10 ml-28"><span className="inline-block w-5 h-5 rounded-full border" style={{ background: employee.couleur_equipe || '#3B82F6' }} data-testid="pastille-couleur_equipe" /></div>}
      </div>
    </SectionFiche>
  );
}
